import { render } from "./NutzerschlagwortBadge.pug?vue&type=template&id=0ac2c35e&lang=pug"
import script from "./NutzerschlagwortBadge.js?vue&type=script&lang=js"
export * from "./NutzerschlagwortBadge.js?vue&type=script&lang=js"

import "./NutzerschlagwortBadge.css?vue&type=style&index=0&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__